import { createTheme } from "@mui/material";

export const themeOptions = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#be3c88',
        },
        secondary: {
            main: '#19b3b8',
        },
        background: {
            default: '#121213'
        },
        error: {
            main: '#ca4754',
        },
        success: {
            main: '#78c729',
        },
        warning: {
            main: '#ed6c02',
        },
    },
    typography: {
        fontFamily: 'Source Code Pro',
        h1: {
            fontFamily: 'Major Mono Display',
        },
        h2: {
            fontFamily: 'Major Mono Display',
        }
    },
});